// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global variables adn mixins are defined here */
::ng-deep .cdk-global-scrollblock {
  overflow: hidden;
}

::ng-deep mat-pseudo-checkbox {
  width: 0px !important;
}

::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {
  width: auto !important;
}

::ng-deep .mdc-list-item__primary-text {
  margin: 0px !important;
}

::ng-deep .mdc-tab__ripple {
  display: none;
}

::ng-deep .mdc-checkbox .mdc-checkbox__native-control:enabled:checked ~ .mdc-checkbox__background,
.mdc-checkbox .mdc-checkbox__native-control:enabled:indeterminate ~ .mdc-checkbox__background,
.mdc-checkbox .mdc-checkbox__native-control[data-indeterminate=true]:enabled ~ .mdc-checkbox__background {
  background-color: #3e97ff !important;
  border-color: #3e97ff !important;
}

.toaster {
  background-color: #f4f7ff !important;
}

/* variables */
/* MIXINS */
/* mixin for border radius */
/* To create a section at the center of window */
/* To include and adjust background image */
/* to split the input */
/* box-shadow generator
    \$clr- in RGBA format
 */
/*
remove the autofilled background color
*/
/* mixin for create buttons */
/* generate margin & padding */
/* to set the table row */
/* to set the image */
/* to set the styles for first and last child div */
/* to set the font style */
.ast-table .table {
  margin-bottom: 0px;
}
.ast-table table thead th {
  background-color: #edeced;
  border: 1px solid #dee2e6;
  border-top: none !important;
}
.ast-table table td {
  background-color: #fafafa;
  color: #231f20;
  border: 0.5px solid #e2e2e1;
  font-size: 16px;
  font-weight: 500;
  font-family: "Amazon Ember Display Light";
}

/* To create a card at the center */
::ng-deep mat-pseudo-checkbox {
  display: none !important;
}

::ng-deep .mat-calendar-body-selected {
  background-color: #3e97ff !important;
}

::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled) .mdc-line-ripple::after {
  border-bottom: none !important;
}

::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled) .mdc-line-ripple::before {
  border-bottom: none !important;
}

::ng-deep .mat-mdc-form-field-has-icon-suffix .mat-mdc-text-field-wrapper {
  background-color: #f2f4ff !important;
}

::ng-deep .mat-form-field {
  border: none !important;
}

.dateselect mat-form-field {
  display: flex;
  height: 25px;
  width: 185px;
  font-size: 12px;
  text-align: center;
  height: 24px;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  margin-top: 7px;
  margin-left: 8px;
}
.dateselect mat-form-field mat-date-range-input {
  color: #959cbd !important;
  display: flex;
  justify-self: center;
}
.dateselect mat-form-field mat-date-range-input ::ng-deep .mat-date-range-input-separator {
  color: #959cbd !important;
}
.dateselect mat-form-field ::ng-deep .mat-date-range-input-content {
  border-bottom: none !important;
}
.dateselect mat-form-field mat-label {
  font-size: 12px;
}
.dateselect mat-form-field ::ng-deep mat-datepicker-toggle {
  background-image: url('calendar-icon.svg');
  background-repeat: no-repeat;
}
.dateselect mat-form-field ::ng-deep mat-datepicker-toggle button {
  margin-left: 35px;
  width: 20px !important;
}
.dateselect mat-form-field ::ng-deep mat-datepicker-toggle .mat-mdc-icon-button svg {
  display: none !important;
}

::ng-deep .mat-mdc-form-field-icon-suffix,
[dir=rtl] .mat-mdc-form-field-icon-prefix {
  width: 30px !important;
  margin-top: 10px;
}

::ng-deep .mat-mdc-form-field-has-icon-suffix .mat-mdc-text-field-wrapper {
  align-items: center;
  border-radius: 5px;
}

::ng-deep .mat-mdc-icon-button {
  --mat-icon-button-hover-state-layer-opacity: 0 !important;
}

::ng-deep .mat-mdc-icon-button .mat-mdc-button-persistent-ripple {
  display: none;
}

.tab-header ::ng-deep .mat-mdc-tab-list {
  align-content: center;
}
.tab-header ::ng-deep .mat-mdc-tab-links {
  gap: 5px;
}

/** Date Picker **/
::ng-deep mat-datepicker-toggle {
  width: 0 !important;
}
::ng-deep mat-datepicker-toggle button {
  position: absolute;
  /* margin-bottom: -20px; */
  top: -23% !important;
  right: 40px;
}

.date-picker {
  height: 25px;
  min-width: 180px;
  font-size: 12px;
  text-align: center;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  margin: 7px 0;
}
.date-picker mat-form-field {
  width: 210px;
}
.date-picker ::ng-deep .mdc-text-field {
  padding-left: 0 !important;
}
.date-picker ::ng-deep .mdc-text-field .mat-mdc-form-field-flex .mat-mdc-form-field-infix {
  padding: 0 !important;
}
.date-picker ::ng-deep .mdc-text-field .mat-mdc-form-field-flex {
  height: 23px;
}
.date-picker ::ng-deep .mdc-text-field .mat-mdc-form-field-flex .mat-mdc-form-field-icon-suffix {
  width: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
}
.date-picker mat-date-range-input {
  color: #959cbd !important;
  display: flex;
  justify-self: center;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-separator {
  color: #959cbd !important;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-inner {
  letter-spacing: 0.5px;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-container {
  justify-content: center;
  font-family: "Poppins";
  width: -moz-fit-content;
  width: fit-content;
  margin: 0 10px;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-content {
  border-bottom: none !important;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-end-wrapper {
  flex-grow: initial !important;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-wrapper {
  width: 70px;
}
.date-picker mat-label {
  font-size: 12px;
}
.date-picker ::ng-deep mat-datepicker-toggle button {
  width: 24px !important;
  height: 24px !important;
  padding: 0 !important;
  transform: translateX(10px);
  background-image: url('calendar-icon.svg');
  background-repeat: no-repeat;
  background-position: center;
}
.date-picker ::ng-deep mat-datepicker-toggle .mat-mdc-icon-button svg {
  display: none !important;
}

/** Date Picker **/
.back-button,
.close-button {
  width: 35px;
  height: 35px;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
  transition: all 0.25s;
}

.back-button {
  background-image: url('back.svg');
}
.back-button:hover {
  background-image: url('back-hover.svg');
}

.close-button {
  background-image: url('close-circle.svg');
}
.close-button:hover {
  background-image: url('close-cirlce-hover.svg');
}

.hover {
  border-radius: 15px;
  overflow: hidden;
}

.side-menu-text {
  color: rgba(0, 0, 0, 0.54);
}

.sidenav {
  height: calc(100vh - 10px);
  display: grid;
  grid-template-rows: 0fr 4fr;
  justify-content: center;
}

.sidenav-responsive {
  display: grid;
  grid-template-rows: 0fr 0fr;
}

.sidenav-container {
  overflow: hidden;
  font-family: "Poppins", sans-serif;
  min-width: 100px !important;
  width: 60px;
  background-color: #ffffff;
}
.sidenav-container .favicon {
  width: 66%;
  height: 75px;
  display: block;
  margin: 10px auto;
  cursor: pointer;
}
.sidenav-container .sidebar-header {
  padding: 30px 20px;
}
.sidenav-container .sidebar-header img {
  float: right;
  cursor: pointer;
}
.sidenav-container ::ng-deep .mat-mdc-list-base {
  --mdc-list-list-item-one-line-container-height: none !important;
  --mdc-list-list-item-hover-state-layer-opacity: 0 !important;
}
.sidenav-container .module-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: auto;
}
.sidenav-container .module-container mat-nav-list {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 7%;
}
.sidenav-container .module-container mat-nav-list mat-list-item {
  margin: 5px 0px;
  background-color: #ffffff;
}
.sidenav-container .module-container mat-nav-list mat-list-item ::ng-deep .mdc-list-item__content {
  display: flex;
  align-items: center;
  justify-content: center;
}
.sidenav-container .module-container mat-nav-list mat-list-item a {
  width: 100%;
  text-align: center;
  text-decoration: none;
}
.sidenav-container .module-container mat-nav-list mat-list-item a .menu-name {
  font-family: "Poppins", sans-serif;
  font-size: 12px;
  color: #5e6278;
  font-weight: 600;
}
.sidenav-container .module-container mat-nav-list mat-list-item a img {
  margin: auto !important;
  height: 40px;
  padding: 6px;
  filter: grayscale(100%) opacity(0.5);
}
.sidenav-container .module-container mat-nav-list mat-list-item a:hover .menu-name {
  color: #3e97ff;
}
.sidenav-container .module-container mat-nav-list mat-list-item a:hover img {
  filter: none;
}
.sidenav-container .module-container mat-nav-list mat-list-item a:active {
  background-color: #3e97ff;
  color: #3e97ff;
  filter: none;
}
.sidenav-container .module-container mat-nav-list mat-list-item .active {
  color: #3e97ff;
}
.sidenav-container .module-container mat-nav-list mat-list-item .active .menu-name {
  color: #3e97ff;
}
.sidenav-container .module-container mat-nav-list mat-list-item .active img {
  padding: 6px;
  height: 40px;
  filter: none;
}
.sidenav-container .module-container mat-nav-list mat-list-item:hover {
  color: #3e97ff !important;
}
.sidenav-container .module-container mat-nav-list mat-list-item:active {
  color: #3e97ff !important;
}

@media screen and (max-width: 769px) {
  .iconClass {
    padding: 10px !important;
  }
  .hover {
    display: grid;
    grid-template-columns: 1fr 1fr;
    padding: 0px 35px;
  }
  mat-nav-list {
    width: 100%;
  }
  mat-nav-list:hover {
    background: none !important;
  }
  .text {
    text-decoration: none;
  }
  mat-list-item {
    padding-left: 0px !important;
    background-color: #F3F6F9 !important;
  }
  mat-list-item img {
    border-radius: 10px;
  }
  mat-list-item:hover {
    color: #ffffff !important;
    background: #3e97ff !important;
  }
  mat-list-item:hover img {
    background-color: #3e97ff !important;
    filter: none !important;
  }
  mat-list-item ::ng-deep .mat-mdc-list-base {
    --mdc-list-list-item-one-line-container-height: none !important;
    --mdc-list-list-item-hover-state-layer-opacity: 0 !important;
  }
  mat-list-item ::ng-deep .mdc-list-item__primary-text {
    width: 100% !important;
  }
  .sidenav-container {
    width: 240px;
    background-color: #F3F6F9 !important;
  }
  .sidenav-container .module-container {
    height: 100%;
  }
  .sidenav-container .module-container mat-nav-list {
    justify-content: flex-start;
  }
  .sidenav-container .module-container mat-nav-list .side-menu a {
    color: rgba(0, 0, 0, 0.54);
  }
  .sidenav-container .module-container mat-nav-list .side-menu a .side-logo .side-menu-text:hover {
    color: #ffffff !important;
  }
  .sidenav-container .module-container mat-nav-list .side-menu a:hover, .sidenav-container .module-container mat-nav-list .side-menu a:focus {
    outline: none;
    background: transparent;
    color: #ffffff;
  }
  .sidenav-container .module-container mat-nav-list .side-menu a:active {
    background-color: #3e97ff !important;
    color: #3e97ff !important;
  }
  .sidenav-container .module-container mat-nav-list .side-menu a:active {
    color: #3e97ff !important;
  }
  .sidenav-container .module-container mat-nav-list .side-menu .active {
    background-color: #3e97ff;
  }
  .sidenav-container .module-container mat-nav-list .side-menu .active .side-logo img {
    height: 40px;
    margin: auto 0px auto -10px;
  }
  .sidenav-container .module-container mat-nav-list .side-menu .active .side-logo .side-menu-text {
    color: #ffffff;
  }
  ::ng-deep .mdc-list-item__primary-text:hover {
    color: #ffffff !important;
    background-color: #3e97ff;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/global.scss","webpack://./src/app/common/sidebar-v2/sidebar-v2.component.scss"],"names":[],"mappings":"AAAA,iDAAA;AAEA;EACE,gBAAA;ACAF;;ADGA;EACE,qBAAA;ACAF;;ADGA;EACE,sBAAA;ACAF;;ADQA;EACE,sBAAA;ACLF;;ADQA;EACE,aAAA;ACLF;;ADQA;;;EAGE,oCAAA;EACA,gCAAA;ACLF;;ADQA;EACE,oCAAA;ACLF;;ADQA,cAAA;AAmDA,WAAA;AAEA,4BAAA;AAcA,gDAAA;AAuBA,2CAAA;AAaA,uBAAA;AAgBA;;EAAA;AAUA;;CAAA;AAcA,6BAAA;AAoEA,8BAAA;AASA,yBAAA;AAuBA,qBAAA;AAQA,mDAAA;AAaA,0BAAA;AAmBE;EACE,kBAAA;AC9QJ;ADsRM;EACE,yBAAA;EACA,yBAAA;EACA,2BAAA;ACpRR;ADwRI;EAtEF,yBAwE2B;EAvE3B,cAuEoC;EAtEpC,2BAsE6C;EArE7C,eAqEkE;EAnElE,gBAAA;EACA,yCAAA;AChNF;;ADuRA,mCAAA;AA8BA;EACE,wBAAA;ACjTF;;ADoTA;EACE,oCAAA;ACjTF;;ADoTA;EACE,8BAAA;ACjTF;;ADoTA;EACE,8BAAA;ACjTF;;ADoTA;EACE,oCAAA;ACjTF;;ADoTA;EACE,uBAAA;ACjTF;;ADqTE;EACE,aAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,kCAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AClTJ;ADoTI;EAKE,yBAAA;EACA,aAAA;EACA,oBAAA;ACtTN;ADgTM;EACE,yBAAA;AC9SR;ADsTI;EACE,8BAAA;ACpTN;ADuTI;EACE,eAAA;ACrTN;ADwTI;EACE,0CAAA;EACA,4BAAA;ACtTN;ADwTM;EACE,iBAAA;EACA,sBAAA;ACtTR;ADyTM;EACE,wBAAA;ACvTR;;AD6TA;;EAEE,sBAAA;EACA,gBAAA;AC1TF;;AD6TA;EACE,mBAAA;EACA,kBAAA;AC1TF;;AD6TA;EACE,yDAAA;AC1TF;;AD6TA;EACE,aAAA;AC1TF;;AD8TE;EACE,qBAAA;AC3TJ;AD8TE;EACE,QAAA;AC5TJ;;ADiUA,kBAAA;AAEA;EACE,mBAAA;AC/TF;ADiUE;EACE,kBAAA;EACA,0BAAA;EACA,oBAAA;EACA,WAAA;AC/TJ;;ADmUA;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,kCAAA;EACA,gBAAA;EACA,aAAA;AChUF;ADkUE;EACE,YAAA;AChUJ;ADmUE;EACE,0BAAA;ACjUJ;ADoUE;EACE,qBAAA;AClUJ;ADqUE;EACE,YAAA;ACnUJ;ADsUE;EACE,mBAAA;EACA,qBAAA;EACA,oBAAA;ACpUJ;ADuUE;EACE,yBAAA;EACA,aAAA;EACA,oBAAA;ACrUJ;ADuUI;EACE,yBAAA;ACrUN;ADyUI;EACE,qBAAA;ACvUN;AD0UI;EACE,uBAAA;EACA,sBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,cAAA;ACxUN;AD2UI;EACE,8BAAA;ACzUN;AD4UI;EACE,6BAAA;AC1UN;AD6UI;EACE,WAAA;AC3UN;AD+UE;EACE,eAAA;AC7UJ;ADiVI;EACE,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,2BAAA;EACA,0CAAA;EACA,4BAAA;EACA,2BAAA;AC/UN;ADkVI;EACE,wBAAA;AChVN;;ADqVA,kBAAA;AAGA;;EAEE,WAAA;EACA,YAAA;EACA,2BAAA;EACA,4BAAA;EACA,eAAA;EACA,qBAAA;ACpVF;;ADuVA;EACE,iCAAA;ACpVF;ADsVE;EACE,uCAAA;ACpVJ;;ADwVA;EACE,yCAAA;ACrVF;ADuVE;EACE,+CAAA;ACrVJ;;AA9PA;EACI,mBAAA;EACA,gBAAA;AAiQJ;;AA9PA;EACI,0BAAA;AAiQJ;;AA9PA;EACI,0BAAA;EACA,aAAA;EACA,2BAAA;EACA,uBAAA;AAiQJ;;AA9PA;EACI,aAAA;EACA,2BAAA;AAiQJ;;AA9PA;EACI,gBAAA;EACA,kCDuDW;ECpDX,2BAAA;EACA,WAAA;EACA,yBD6CI;ACkNR;AA7PI;EACI,UAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;AA+PR;AA5PI;EACI,kBAAA;AA8PR;AA5PQ;EACI,YAAA;EACA,eAAA;AA8PZ;AAzPI;EACI,+DAAA;EACA,4DAAA;AA2PR;AAxPI;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AA0PR;AAvPQ;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AAyPZ;AAvPY;EACI,eAAA;EACA,yBAAA;AAyPhB;AAvPgB;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;AAyPpB;AAtPgB;EACI,WAAA;EACA,kBAAA;EACA,qBAAA;AAwPpB;AAtPoB;EACI,kCDLT;ECMS,eAAA;EACA,cDzBb;EC0Ba,gBDHV;AC2Pd;AApPoB;EACI,uBAAA;EACA,YAAA;EACA,YAAA;EACA,oCAAA;AAsPxB;AA9OoB;EACI,cDpCV;ACoRd;AA7OoB;EACI,YAAA;AA+OxB;AA3OgB;EACI,yBD7CN;EC8CM,cD9CN;EC+CM,YAAA;AA6OpB;AA1OgB;EACI,cDnDN;AC+Rd;AA1OoB;EACI,cDtDV;ACkSd;AAzOoB;EAGI,YAAA;EAEA,YAAA;EAEA,YAAA;AAuOxB;AAjOY;EAEI,yBAAA;AAkOhB;AA/NY;EAEI,yBAAA;AAgOhB;;AA1NA;EACI;IACI,wBAAA;EA6NN;EA1NE;IACI,aAAA;IACA,8BAAA;IACA,iBAAA;EA4NN;EAzNE;IAKI,WAAA;EAuNN;EA3NM;IACI,2BAAA;EA6NV;EAvNE;IACI,qBAAA;EAyNN;EAtNE;IAiBI,4BAAA;IACA,oCAAA;EAwMN;EAzNM;IACI,mBAAA;EA2NV;EAxNM;IAQI,yBAAA;IACA,8BAAA;EAmNV;EA3NU;IAEI,oCAAA;IACA,uBAAA;EA4Nd;EAjNM;IACI,+DAAA;IACA,4DAAA;EAmNV;EAhNM;IACI,sBAAA;EAkNV;EA7ME;IACI,YAAA;IACA,oCAAA;EA+MN;EA7MM;IACI,YAAA;EA+MV;EA7MU;IAEI,2BAAA;EA8Md;EA1MkB;IACI,0BAAA;EA4MtB;EAxM8B;IACI,yBAAA;EA0MlC;EArMsB;IAEI,aAAA;IACA,uBAAA;IACA,cD/JpB;ECqWN;EAjMsB;IACI,oCAAA;IACA,yBAAA;EAmM1B;EA/LkB;IACI,yBAAA;EAiMtB;EA9LkB;IACI,yBDrLV;ECqXZ;EA7L0B;IAEI,YAAA;IACA,2BAAA;EA8L9B;EA3L0B;IACI,cDzLxB;ECsXN;EAlLM;IACI,yBAAA;IACA,yBD5ME;ECgYZ;AACF","sourcesContent":["/* Global variables adn mixins are defined here */\n\n::ng-deep .cdk-global-scrollblock {\n  overflow: hidden;\n}\n\n::ng-deep mat-pseudo-checkbox {\n  width: 0px !important;\n}\n\n::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {\n  width: auto !important;\n  // height: auto !important;\n}\n\n// ::ng-deep mat-option{\n//     display: flex !important;\n//     justify-content: center !important;\n// }\n::ng-deep .mdc-list-item__primary-text {\n  margin: 0px !important;\n}\n\n::ng-deep .mdc-tab__ripple {\n  display: none;\n}\n\n::ng-deep .mdc-checkbox .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background,\n.mdc-checkbox .mdc-checkbox__native-control:enabled:indeterminate~.mdc-checkbox__background,\n.mdc-checkbox .mdc-checkbox__native-control[data-indeterminate=\"true\"]:enabled~.mdc-checkbox__background {\n  background-color: #3e97ff !important;\n  border-color: #3e97ff !important;\n}\n\n.toaster {\n  background-color: #f4f7ff !important;\n}\n\n/* variables */\n\n$primary: #3e97ff;\n$primary-active: #2884ef;\n$primary-light: #f2f4ff;\n$success: #50cd89;\n$success-active: #50cd89;\n$success-light: #e8fff3;\n$danger: #ff4b55;\n$danger-active: #d9214e;\n$danger-light: #fff5f8;\n$info: #7dcfdb;\n$info-active: #4fc9da;\n$info-light: #edf9fb;\n$warning: #ffa800;\n$warning-active: #ffa800;\n$warning-light: #fff7e7;\n$white: #ffffff;\n$white-active: #f5f8fa;\n$dark: #181c32;\n$gray-100: #f9f9f9;\n$gray-200: #f1f1f2;\n$gray-300: #e1e3ea;\n$gray-400: #d8d8e5;\n$gray-500: #959cbd;\n$gray-600: #7e8299;\n$gray-700: #5e6278;\n$gray-800: #3f4254;\n$gray-900: #181c32;\n$gray-button: #1e2238;\n\n//\n$primary-clr-dark: #232f3e;\n$primary-clr: #3e97ff;\n$primary-clr-alpha: #00a8e1;\n$bg-clr: #f3f3f3;\n$bg-clr-alpha: #edeced;\n$primary-ft-clr: #595a5c;\n$primary-grey: #707070;\n$white: #ffffff;\n$black: #3f4254;\n// $success: #347439;\n$failure: #ff0000;\n$grey: #cccccc;\n$primary-font: \"Poppins\", sans-serif;\n$ft-thin: 300;\n$ft-regular: 400;\n$ft-500: 500;\n$ft-bold: 700;\n$ft-semibold: 600;\n\n/* MIXINS */\n\n/* mixin for border radius */\n\n@mixin border-radius($top, $right, $bottom, $left) {\n  -webkit-border-radius: $top $right $bottom $left;\n  -moz-border-radius: $top $right $bottom $left;\n  border-radius: $top $right $bottom $left;\n}\n\n@mixin border-single-radius($rad) {\n  -webkit-border-radius: $rad;\n  -moz-border-radius: $rad;\n  border-radius: $rad;\n}\n\n/* To create a section at the center of window */\n@mixin create-centered-section($width,\n  $border-radius,\n  $padding-tb,\n  $padding-lr,\n  $border,\n  $background,\n  $left) {\n  position: absolute;\n  margin: auto;\n  top: 0;\n  left: $left;\n  right: 0;\n  bottom: 0;\n  width: $width;\n  height: 50vh;\n  // max-height: 520px;\n  border-radius: $border-radius;\n  padding: $padding-tb $padding-lr;\n  border: $border;\n  background: $background;\n}\n\n/* To include and adjust background image */\n@mixin set-background-image($bg-color,\n  $bg-url,\n  $bg-position,\n  $bg-repeat,\n  $bg-size) {\n  background: $bg-color;\n  background-image: $bg-url;\n  background-position: $bg-position;\n  background-repeat: $bg-repeat;\n  background-size: $bg-size;\n}\n\n/* to split the input */\n@mixin split-input($ltr-space,\n  $bg-img,\n  $bg-position,\n  $bg-size,\n  $bg-repeat,\n  $bg-pos-x) {\n  border: 0;\n  letter-spacing: $ltr-space;\n  background-image: $bg-img;\n  background-position: bottom;\n  background-size: $bg-size;\n  background-repeat: $bg-repeat;\n  background-position-x: $bg-pos-x;\n}\n\n/* box-shadow generator\n    $clr- in RGBA format\n */\n\n@mixin box-shadows($hset, $vset, $blur, $spread, $clr) {\n  -webkit-box-shadow: $hset $vset $blur $spread $clr;\n  -moz-box-shadow: $hset $vset $blur $spread $clr;\n  box-shadow: $hset $vset $blur $spread $clr;\n}\n\n/*\nremove the autofilled background color\n*/\n@mixin remove-autofill-background() {\n\n  input:-webkit-autofill,\n  input:-webkit-autofill:hover,\n  input:-webkit-autofill:focus,\n  input:-webkit-autofill:active {\n    transition-delay: 99999s;\n    -webkit-transition-delay: 99999s;\n  }\n}\n\n/* mixin for create buttons */\n\n@mixin create-buttons($bgClr,\n  $clr,\n  $ptb,\n  $plr,\n  $width,\n  $height,\n  $ft-size,\n  $ft-weight,\n  $rad) {\n  display: inline-block;\n  // padding: $ptb $plr;\n  margin-bottom: 0;\n  line-height: calc($height/2);\n  text-align: left;\n  white-space: nowrap;\n  vertical-align: middle;\n  -ms-touch-action: manipulation;\n  touch-action: manipulation;\n  cursor: pointer;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  background-image: none;\n  border: 1px solid transparent;\n  @include border-single-radius($rad);\n  font-size: $ft-size;\n  font-weight: $ft-weight;\n  height: $height;\n  min-width: $width;\n  background: $bgClr;\n  color: $clr;\n  position: relative;\n  text-align: center;\n\n  &:disabled {\n    cursor: not-allowed;\n  }\n\n  &:focus {\n    outline: none;\n  }\n\n  &:hover,\n  &:focus,\n  &:active {\n    // background: $clr;\n    // color: $bgClr;\n    // border: 1px solid $bgClr;\n    transition-duration: 0.5s;\n    transition-timing-function: ease-in-out;\n    text-decoration: none;\n  }\n}\n\n@mixin no-transition($bg-color, $color) {\n\n  &:hover,\n  &:focus,\n  &:active {\n    background: $bg-color;\n    color: $color;\n    border: 1px solid $bg-color;\n  }\n}\n\n/* generate margin & padding */\n@mixin generate-margin($tp, $rt, $bt, $lt) {\n  margin: $tp $rt $bt $lt;\n}\n\n@mixin generate-padding($tp, $rt, $bt, $lt) {\n  padding: $tp $rt $bt $lt;\n}\n\n/* to set the table row */\n@mixin set-table-row($bg-color,\n  $color,\n  $border,\n  $font-size,\n  $font-weight,\n  $fontFamily: \"\"\n\n) {\n  background-color: $bg-color;\n  color: $color;\n  border: $border;\n  font-size: $font-size;\n  // font-weight: $font-weight;\n  font-weight: 500;\n  font-family: \"Amazon Ember Display Light\";\n\n  @if $fontFamily !=\"\" {\n    font-family: $fontFamily;\n    font-weight: $font-weight;\n  }\n}\n\n/* to set the image */\n@mixin set-image-config($width, $height, $cursor, $margin-right) {\n  width: $width;\n  height: $height;\n  cursor: $cursor;\n  margin-right: $margin-right;\n}\n\n/* to set the styles for first and last child div */\n@mixin set-child-div($color1, $font-size1, $font-weight1, $color2) {\n  div:first-child {\n    color: $color1;\n    font-size: $font-size1;\n    font-weight: $font-weight1;\n  }\n\n  div:last-child {\n    color: $color2;\n  }\n}\n\n/* to set the font style */\n@mixin set-font-config($fontSize,\n  $fontWeight,\n  $fontColor,\n  $textAlign,\n  $fontFamily: \"\"\n\n) {\n  font-size: $fontSize;\n  font-weight: $fontWeight;\n  color: $fontColor;\n  text-align: $textAlign;\n\n  @if $fontFamily !=\"\" {\n    font-family: $fontFamily;\n  }\n}\n\n.ast-table {\n  .table {\n    margin-bottom: 0px;\n  }\n\n  table {\n    thead {\n\n      // @mixin set-table-row($bg-color, $color, $border, $font-size, $font-weight)\n      // @include set-table-row($white, #231f20, 0.5px solid #e2e2e1, 16px, 300) ;\n      th {\n        background-color: #edeced;\n        border: 1px solid #dee2e6;\n        border-top: none !important;\n      }\n    }\n\n    td {\n      // @mixin set-table-row($bg-color, $color, $border, $font-size, $font-weight)\n      @include set-table-row(#fafafa, #231f20, 0.5px solid #e2e2e1, 16px, 300);\n    }\n  }\n}\n\n/* To create a card at the center */\n@mixin create-card($width,\n  $height,\n  $border-radius,\n  $padding-tb,\n  $padding-lr,\n  $border,\n  $background,\n  $left) {\n  position: relative;\n  margin: auto;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  width: $width;\n  height: $height;\n  border-radius: $border-radius;\n  padding: $padding-tb $padding-lr;\n  border: $border;\n  background: $background;\n  text-align: center;\n}\n\n@mixin flexbox($display, $align-items, $justify-content) {\n  display: $display;\n  align-items: $align-items;\n  justify-content: $justify-content;\n}\n\n::ng-deep mat-pseudo-checkbox {\n  display: none !important;\n}\n\n::ng-deep .mat-calendar-body-selected {\n  background-color: $primary !important;\n}\n\n::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled) .mdc-line-ripple::after {\n  border-bottom: none !important;\n}\n\n::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled) .mdc-line-ripple::before {\n  border-bottom: none !important;\n}\n\n::ng-deep .mat-mdc-form-field-has-icon-suffix .mat-mdc-text-field-wrapper {\n  background-color: $primary-light !important;\n}\n\n::ng-deep .mat-form-field {\n  border: none !important;\n}\n\n.dateselect {\n  mat-form-field {\n    display: flex;\n    height: 25px;\n    width: 185px;\n    font-size: 12px;\n    text-align: center;\n    height: 24px;\n    font-family: \"Poppins\", sans-serif;\n    font-weight: 500;\n    margin-top: 7px;\n    margin-left: 8px;\n\n    mat-date-range-input {\n      ::ng-deep .mat-date-range-input-separator {\n        color: #959cbd !important;\n      }\n\n      color: #959cbd !important;\n      display: flex;\n      justify-self: center;\n    }\n\n    ::ng-deep .mat-date-range-input-content {\n      border-bottom: none !important;\n    }\n\n    mat-label {\n      font-size: 12px;\n    }\n\n    ::ng-deep mat-datepicker-toggle {\n      background-image: url(../images/calendar-icon.svg);\n      background-repeat: no-repeat;\n\n      button {\n        margin-left: 35px;\n        width: 20px !important;\n      }\n\n      .mat-mdc-icon-button svg {\n        display: none !important;\n      }\n    }\n  }\n}\n\n::ng-deep .mat-mdc-form-field-icon-suffix,\n[dir=\"rtl\"] .mat-mdc-form-field-icon-prefix {\n  width: 30px !important;\n  margin-top: 10px;\n}\n\n::ng-deep .mat-mdc-form-field-has-icon-suffix .mat-mdc-text-field-wrapper {\n  align-items: center;\n  border-radius: 5px;\n}\n\n::ng-deep .mat-mdc-icon-button {\n  --mat-icon-button-hover-state-layer-opacity: 0 !important;\n}\n\n::ng-deep .mat-mdc-icon-button .mat-mdc-button-persistent-ripple {\n  display: none;\n}\n\n.tab-header {\n  ::ng-deep .mat-mdc-tab-list {\n    align-content: center;\n  }\n\n  ::ng-deep .mat-mdc-tab-links {\n    gap: 5px;\n  }\n}\n\n\n/** Date Picker **/\n\n::ng-deep mat-datepicker-toggle {\n  width: 0 !important;\n\n  button {\n    position: absolute;\n    /* margin-bottom: -20px; */\n    top: -23% !important;\n    right: 40px;\n  }\n}\n\n.date-picker {\n  height: 25px;\n  min-width: 180px;\n  font-size: 12px;\n  text-align: center;\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 500;\n  margin: 7px 0;\n\n  mat-form-field {\n    width: 210px;\n  }\n\n  ::ng-deep .mdc-text-field {\n    padding-left: 0 !important;\n  }\n\n  ::ng-deep .mdc-text-field .mat-mdc-form-field-flex .mat-mdc-form-field-infix {\n    padding: 0 !important;\n  }\n\n  ::ng-deep .mdc-text-field .mat-mdc-form-field-flex {\n    height: 23px;\n  }\n\n  ::ng-deep .mdc-text-field .mat-mdc-form-field-flex .mat-mdc-form-field-icon-suffix {\n    width: 0 !important;\n    padding: 0 !important;\n    margin: 0 !important;\n  }\n\n  mat-date-range-input {\n    color: #959cbd !important;\n    display: flex;\n    justify-self: center;\n\n    ::ng-deep .mat-date-range-input-separator {\n      color: #959cbd !important;\n      // margin: 0 10px;\n    }\n\n    ::ng-deep .mat-date-range-input-inner {\n      letter-spacing: 0.5px;\n    }\n\n    ::ng-deep .mat-date-range-input-container {\n      justify-content: center;\n      font-family: \"Poppins\";\n      width: fit-content;\n      margin: 0 10px;\n    }\n\n    ::ng-deep .mat-date-range-input-content {\n      border-bottom: none !important;\n    }\n\n    ::ng-deep .mat-date-range-input-end-wrapper {\n      flex-grow: initial !important;\n    }\n\n    ::ng-deep .mat-date-range-input-wrapper {\n      width: 70px;\n    }\n  }\n\n  mat-label {\n    font-size: 12px;\n  }\n\n  ::ng-deep mat-datepicker-toggle {\n    button {\n      width: 24px !important;\n      height: 24px !important;\n      padding: 0 !important;\n      transform: translateX(10px);\n      background-image: url(../images/calendar-icon.svg);\n      background-repeat: no-repeat;\n      background-position: center;\n    }\n\n    .mat-mdc-icon-button svg {\n      display: none !important;\n    }\n  }\n}\n\n/** Date Picker **/\n\n\n.back-button,\n.close-button {\n  width: 35px;\n  height: 35px;\n  background-position: center;\n  background-repeat: no-repeat;\n  cursor: pointer;\n  transition: all .25s;\n}\n\n.back-button {\n  background-image: url('../images/back.svg');\n\n  &:hover {\n    background-image: url('../images/back-hover.svg');\n  }\n}\n\n.close-button {\n  background-image: url('../images/close-circle.svg');\n\n  &:hover {\n    background-image: url('../images/close-cirlce-hover.svg');\n  }\n}","@import \"../../../assets/styles/global.scss\";\n\n\n\n.hover {\n    border-radius: 15px;\n    overflow: hidden;\n}\n\n.side-menu-text {\n    color: rgba(0, 0, 0, 0.54)\n}\n\n.sidenav {\n    height: calc(100vh - 10px);\n    display: grid;\n    grid-template-rows: 0fr 4fr;\n    justify-content: center;\n}\n\n.sidenav-responsive {\n    display: grid;\n    grid-template-rows: 0fr 0fr;\n}\n\n.sidenav-container {\n    overflow: hidden;\n    font-family: $primary-font;\n    // height: calc(100vh - 10px);\n    // height: auto;\n    min-width: 100px !important;\n    width: 60px;\n    background-color: $white;\n\n    .favicon {\n        width: 66%;\n        height: 75px;\n        display: block;\n        margin: 10px auto;\n        cursor: pointer;\n    }\n\n    .sidebar-header {\n        padding: 30px 20px;\n\n        img {\n            float: right;\n            cursor: pointer;\n        }\n\n    }\n\n    ::ng-deep .mat-mdc-list-base {\n        --mdc-list-list-item-one-line-container-height: none !important;\n        --mdc-list-list-item-hover-state-layer-opacity: 0 !important;\n    }\n\n    .module-container {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        height: auto;\n\n        // height: calc(100vh - 150px);\n        mat-nav-list {\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            justify-content: center;\n            margin-bottom: 7%;\n\n            mat-list-item {\n                margin: 5px 0px;\n                background-color: #ffffff;\n\n                ::ng-deep .mdc-list-item__content {\n                    display: flex;\n                    align-items: center;\n                    justify-content: center;\n                }\n\n                a {\n                    width: 100%;\n                    text-align: center;\n                    text-decoration: none;\n\n                    .menu-name {\n                        font-family: $primary-font;\n                        font-size: 12px;\n                        color: $gray-700;\n                        font-weight: $ft-semibold;\n\n                    }\n\n                    img {\n                        margin: auto !important;\n                        height: 40px;\n                        padding: 6px;\n                        filter: grayscale(100%) opacity(0.5);\n                        // -webkit-filter: grayscale(1); \n                        // filter: grayscale(1);\n\n                    }\n                }\n\n                a:hover {\n                    .menu-name {\n                        color: $primary-clr;\n                    }\n\n                    img {\n                        filter: none;\n                    }\n                }\n\n                a:active {\n                    background-color: $primary-clr;\n                    color: $primary-clr;\n                    filter: none;\n                }\n\n                .active {\n                    color: $primary-clr;\n\n                    .menu-name {\n                        color: $primary-clr;\n                    }\n\n                    img {\n                        // border:1px solid $primary-clr;\n                        // border-radius: 15px;\n                        padding: 6px;\n                        // background-color: $primary-clr;\n                        height: 40px;\n                        // margin: auto 0px auto -10px;\n                        filter: none;\n                    }\n\n                }\n            }\n\n            mat-list-item:hover {\n                // background-color: $primary-clr;\n                color: $primary-clr !important;\n            }\n\n            mat-list-item:active {\n                // background-color: $primary-clr;\n                color: $primary-clr !important;\n            }\n        }\n    }\n}\n\n@media screen and (max-width: 769px) {\n    .iconClass {\n        padding: 10px !important;\n    }\n\n    .hover {\n        display: grid;\n        grid-template-columns: 1fr 1fr;\n        padding: 0px 35px\n    }\n\n    mat-nav-list {\n        &:hover {\n            background: none !important;\n        }\n\n        width: 100%;\n    }\n\n    .text {\n        text-decoration: none;\n    }\n\n    mat-list-item {\n        img {\n            border-radius: 10px;\n        }\n\n        &:hover {\n            img {\n                // &:hover{\n                background-color: $primary-clr !important;\n                filter: none !important;\n                // }\n            }\n\n            color: $white !important;\n            background: $primary-clr !important;\n        }\n\n        padding-left: 0px !important;\n        background-color: #F3F6F9 !important;\n\n        ::ng-deep .mat-mdc-list-base {\n            --mdc-list-list-item-one-line-container-height: none !important;\n            --mdc-list-list-item-hover-state-layer-opacity: 0 !important;\n        }\n\n        ::ng-deep .mdc-list-item__primary-text {\n            width: 100% !important;\n        }\n\n    }\n\n    .sidenav-container {\n        width: calc(250px - 10px);\n        background-color: #F3F6F9 !important;\n\n        .module-container {\n            height: 100%;\n\n            mat-nav-list {\n\n                justify-content: flex-start;\n\n                .side-menu {\n\n                    a {\n                        color: rgba(0, 0, 0, .54);\n\n                        .side-logo {\n                            .side-menu-text {\n                                &:hover {\n                                    color: $white !important;\n                                }\n                            }\n                        }\n\n                        &:hover,\n                        &:focus {\n                            outline: none;\n                            background: transparent;\n                            color: $white;\n                            // background-color: $white;\n                            // background: rgba(0,0,0,0) !important;\n                        }\n\n                        &:active {\n                            background-color: $primary-clr !important;\n                            color: $primary-clr !important;\n                        }\n                    }\n\n                    a:active {\n                        color: $primary-clr !important;\n                    }\n\n                    .active {\n                        background-color: $primary-clr;\n\n                        .side-logo {\n                            img {\n\n                                height: 40px;\n                                margin: auto 0px auto -10px;\n                            }\n\n                            .side-menu-text {\n                                color: $white;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    ::ng-deep .mdc-list-item__primary-text {\n\n        &:hover {\n            color: $white !important;\n            background-color: $primary-clr;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
